export default __webpack_public_path__ + "static/media/orderIcon.6c75734e.svg";